import { BankClosureTool, IncomeTaxCalculator, NationalInsuranceCalculator } from './importers'

export const toolComponentMap = {
  bankClosure: {
    component: BankClosureTool,
    dataValidation: ['bank', 'branch', 'localAuthority', 'closingDate', 'postcode'],
  },
  councilTax: {
    component: BankClosureTool,
    dataValidation: ['country', 'area', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'],
  },
  nationalInsuranceCalculator: {
    component: NationalInsuranceCalculator,
    dataValidation: [
      'employedAdditional',
      'employedRate',
      'financialYear',
      'highRate',
      'lowRate',
      'lowThreshold',
      'mediumThreshold',
      'minLowThreshold',
      'selfAdditional',
      'selfRate',
    ],
  },
  incomeTaxCalculator: {
    component: IncomeTaxCalculator,
    dataValidation: [
      'taxYear',
      'personalAllowanceLimit',
      'lowRate',
      'midRate',
      'highRate',
      'lowThreshold',
      'midThreshold',
      'highThreshold',
      'startRateScot',
      'basicRateScot',
      'intermediateRateScot',
      'higherRateScot',
      'topRateScot',
      'lowThresholdScot',
      'startThresholdScot',
      'basicThresholdScot',
      'intermediateThresholdScot',
      'advancedThresholdScot',
      'highThresholdScot',
      'lowRateNi',
      'mediumRateNi',
      'highRateNi',
      'lowThresholdNi',
      'mediumThresholdNi',
    ],
  },
}

export type ComponentType = keyof typeof toolComponentMap
